<template>
  <div class="comparison-container">
    <BackgroundGridBlue class="comparison-background">
      <CarouselSliderBox
        id="comparison-slider"
        class="comparison-slider"
        orientation="horizontal"
        :slides-to-show="1"
        :gap="windowWidth <= 600 ? '10px' : 'auto'"
        :extra-slide-size="windowWidth <= 600 ? '8%' : '12%'"
        :infinite-loop="false"
        :autoplay="false"
        :show-slider-controls="false"
        slider-pagination-class="comparison-pagination"
      >
        <BeforeListSlide />
        <UkaskoListSlide />
      </CarouselSliderBox>
      <div class="comparison__footer"></div>
    </BackgroundGridBlue>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import BeforeListSlide from './before-list-slide';
import UkaskoListSlide from './ukasko-list-slide';
import { BackgroundGridBlue } from '@/shared/ui/promo';
import { CarouselSliderBox } from '@/shared/ui/slider';

export default {
  components: { BackgroundGridBlue, CarouselSliderBox, BeforeListSlide, UkaskoListSlide },
  computed: {
    ...mapGetters('layoutModule', ['windowWidth']),
  }
};
</script>

<style scoped lang="scss">
.comparison {
  &-container {
    display: flex;
    justify-content: center;
  }

  &-background {
    position: relative;
    display: flex;
    justify-content: center;
    padding: 70px 0 0;
  }

  &-slider {
    ::v-deep .carousel-slider__track {
      align-items: flex-start !important;
    }

    ::v-deep .feature-list--simple,
    ::v-deep .feature-list--fancy {
      opacity: 1;
      height: auto;
      animation: none;
      transform: none;

      .feature-list__item {
        opacity: 1;
        max-width: none;
        transform: none;
        animation: none;
      }
    }
  }

  &-pagination {
    bottom: 30px;

    ::v-deep .slider-pagination__dot {
      background-color: #CADDFC;
      height: 3px;
      width: 240px;

      &--active {
        background-color: #6171E4;
      }
    }
  }

  &__footer {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 25px;
    background: linear-gradient(to bottom, rgba(202, 221, 252, 0) 0%, rgba(255, 255, 255, 0.8) 100%);
  }
}

.before-list {
  margin-right: 16px;
}
</style>
